import React from "react";
import { Link } from "react-router-dom";
import ApexChartComponent from "./Chart";

const GraphModal = (props) => {
  return (
    <>
      {/* Delete Performance Indicator Modal */}
      <div className="modal custom-modal fade" id="delete" role="dialog">
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ minWidth: "800px" }}
        >
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{props.Name}</h3>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-12">
                    <ApexChartComponent />
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-info cancel-btn"
                    >
                      Close
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default GraphModal;
